import script from "./ContractManagementView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractManagementView.vue?vue&type=script&setup=true&lang=js"

import "./ContractManagementView.vue?vue&type=style&index=0&id=4d6b20f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d6b20f6"]])

export default __exports__